module.exports = __webpack_public_path__ + "static/bosch.49024fc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/logos/bosch.svg
// module id = 718
// module chunks = 213534597649335